<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";

const emit = defineEmits(['back', 'confirm']);
defineProps({
  input: {
    type: String,
    required: true,
  },
  secondaryInput: {
    type: [String, null],
    required: false,
    default: null,
  }
})

const handleContinue = () => {
  emit('confirm');
}
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="thinking"
          />

          <ModalHeader>
            <ModalHeading>Ready to Publish?</ModalHeading>

            <ModalSubText>
              You’re about to publish the change shown below. By confirming, you agree that this update will be made live — either as a change to your website or an update to your Google Business Profile, depending on the context.
            </ModalSubText>

            <ModalSubText>
              Please review the content carefully before continuing.
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-flex-col tw-gap-6">
          <span class="tw-flex tw-gap-3 tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none">
            <slot name="label" />
          </span>

          <div class="tw-p-8 tw-border tw-border-neutral tw-rounded-lg tw-w-full tw-text-neutral-900 tw-text-base tw-resize-none">
            {{ input }}
          </div>

          <span
            v-if="secondaryInput"
            class="tw-flex tw-gap-3 tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none"
          >
            <slot name="secondaryLabel" />
          </span>

          <div
            v-if="secondaryInput"
            class="tw-p-8 tw-border tw-border-neutral tw-rounded-lg tw-w-full tw-text-neutral-900 tw-text-base tw-resize-none"
          >
            {{ secondaryInput }}
          </div>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('back')"
          >
            Go Back
          </DefaultButton>
          <DefaultButton
            @click="handleContinue"
          >
            Publish
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
